import { render } from "./CategoriesPage.vue?vue&type=template&id=52453b01&scoped=true"
import script from "./CategoriesPage.vue?vue&type=script&lang=js"
export * from "./CategoriesPage.vue?vue&type=script&lang=js"

import "./CategoriesPage.vue?vue&type=style&index=0&id=52453b01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52453b01"]])

export default __exports__